<a
  class="navigation-card"
  [class.navigation-card--disabled]="disabled"
  [routerLink]="disabled ? null : route"
  [attr.role]="route ? null : 'button'"
  [attr.tabindex]="route || disabled ? null : 0"
  (click)="select()"
  (keydown.enter)="select()"
>
  <div class="card-icon-wrapper">
    <lucide-angular class="card-icon" [name]="icon" [size]="38"></lucide-angular>
  </div>

  <div class="card-content">
    <span class="card-title">
      {{ title | translate }}
      <lucide-angular *ngIf="opensNewTab" name="externalLink" class="external-icon" [size]="18" aria-hidden="true"></lucide-angular>
    </span>

    <span class="card-subtitle" *ngIf="subtitle">
      {{ subtitle | translate }}
    </span>
  </div>
</a>
